module.exports = __webpack_public_path__ + "img/help-24px-blue.f2b2ed44.svg";